import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { IFormPartners } from 'legacy/lut/classes/models/IFormPartners'
import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import {
  IJBPPartnerGroupsExtData,
  IPartnerGroupFromT1187,
} from 'legacy/lut/classes/models/partner360/IPartnerGroup'
import { appGetState } from 'legacy/lut/store'

import { Logic, Operator } from 'core-components/types'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { CrudStore } from 'core/types/crudStore'
import settings from 'src/config/settings'

interface IGetEltDataPayload {
  pid: string
  groupId: number | null
  forceUpdate: boolean
}
interface ICreatePPTXResponseData {
  Status: string
  Message: string
  Path: string
}

interface ICreatePPTXResponse {
  status: string
  data: ICreatePPTXResponseData
}
export const getFetchDataFilter = (
  partnerId: string | null | undefined,
  groupId: number | null
) => {
  const partnerFilter = { field: 'PartnerId', operator: Operator.EQUAL, value: partnerId || null }
  const partnerGroupFilter = {
    field: 'GroupId',
    operator: Operator.EQUAL,
    value: groupId,
  }
  if (groupId) {
    return {
      logic: Logic.AND,
      filters: [partnerGroupFilter],
    }
  }
  return {
    logic: Logic.AND,
    filters: [partnerFilter],
  }
}

class EltStoreService {
  public reFetchGroupInfo = () => {
    const crud = CrudStore.get<IELTData>(
      CrudStoreItemPartner360.JBPEltData,
      'changeGroupMainHqPartner'
    )
    crud.removeQueries(true)
  }

  public getEltData = async ({
    forceUpdate,
    groupId,
    pid,
  }: IGetEltDataPayload): Promise<IELTData[]> => {
    const crud = CrudStore.get<IELTData>(CrudStoreItemPartner360.JBPEltData)
    crud.setFilter(getFetchDataFilter(pid, groupId))
    const res = await crud.fetch({ force: forceUpdate })
    return res?.items || []
  }

  public getCompanyByPartnerId = async (pid: string): Promise<IFormPartners | null> => {
    const crud = CrudStore.get(CrudStoreItem.PartnerAllData)
    crud.setDefaultFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'PartnerId',
          operator: Operator.EQUAL,
          value: pid,
        },
      ],
    })

    const res = await crud.fetch()
    return res?.items?.[0] || null
  }

  public getGroupAttendees = async (groupId: number): Promise<IPartnerGroupFromT1187[]> => {
    const crud = CrudStore.get(CrudStoreItemPartner360.JBPPartnerGroups, 'getGroupAttendees')
    crud.setDefaultFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'GroupId',
          operator: Operator.EQUAL,
          value: groupId,
        },
      ],
    })

    const res = await crud.fetch({ force: true })
    return res.items
  }
  public getPartnerIdGroups = async (partnerId: string): Promise<IPartnerGroupFromT1187[]> => {
    const crud = CrudStore.get(CrudStoreItemPartner360.JBPPartnerGroups, 'getPartnerIdGroups')
    crud.setDefaultFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'PartnerId',
          operator: Operator.EQUAL,
          value: partnerId,
        },
      ],
    })

    const res = await crud.fetch()
    return res.items
  }

  public deletePartnerIdFromGroup = async (item: IJBPPartnerGroupsExtData) => {
    const crud = CrudStore.get(CrudStoreItemPartner360.JBPPartnerGroups, 'usePartnerGroups')
    await crud.delete({ code: 'partner-global-linkage-1187', formId: '1187' }, item, 'EntryId')
  }

  public createDocument = async (entryId: number, format?: string) => {
    try {
      const formatParam = format ? `&format=${format}` : ''
      const endpoint = `/api/v0/eltBriefing/generate?entryId=${entryId}${formatParam}`
      const url = `${settings.httpsServices.partner360}${endpoint}`
      const [accessToken] = getTokens(appGetState().app.ownerId)
      const init: RequestInit = {
        headers: {
          Authorization: `${accessToken}`,
        },
        method: 'GET',
      }
      const response = await fetch(url, init)
      const responseData = (await response.json()) as ICreatePPTXResponse
      const path = responseData?.data?.[0]?.Path
      if (path) {
        return `${settings.dataServerUrl}${path}`
      }
      return null
    } catch (e) {
      return null
    }
  }
}

export default new EltStoreService()
